import { useMemo } from 'react';

import { translate } from '../../../common/helpers/translate.helper';
import { AuthenticationMethod } from '../components/mfa/AuthenticationMethod';

export interface AuthenticatorAppRow {
    id: string;
    method: string;
    dateAdded?: string;
    lastUsed?: string;
}

interface MfaMethodTypes {
    authenticatorAppData: AuthenticatorAppRow[];
    hasTotpMethod: boolean;
    hasRecoveryCode: boolean;
}

export const useMfaMethodTypes = (methods: AuthenticationMethod[]): MfaMethodTypes => {
    return useMemo(() => {
        const mfaMethods = methods.filter((method) => method.type === 'totp' || method.type === 'recovery-code');
        const totpMethod = mfaMethods.find((method) => method.type === 'totp');
        const recoveryCodeMethod = mfaMethods.find((method) => method.type === 'recovery-code');

        const authenticatorAppData: AuthenticatorAppRow[] = totpMethod
            ? [
                  {
                      method: translate('mfa.authenticator.methodName'),
                      dateAdded: totpMethod.createdAt,
                      lastUsed: totpMethod.lastAuthAt,
                      id: totpMethod.id,
                  },
              ]
            : [];

        return {
            authenticatorAppData,
            hasTotpMethod: !!totpMethod,
            hasRecoveryCode: !!recoveryCodeMethod,
        };
    }, [methods]);
};
